import React, { useEffect, useRef, useState } from "react";
import axios from "axios"; // Ou seu axiosInstance
import { renderAsync } from "docx-preview";
import "./DocxPreview.css"; // Importa o CSS que você criou

const DocxViewer = ({ url, height = "100%" }) => {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadDocx = async () => {
      if (!url) return;
      setLoading(true);
      setError(null);

      try {
        // Baixa o arquivo como Blob
        const response = await axios.get(url, { responseType: "blob" });
        
        if (isMounted && containerRef.current) {
          // Limpa conteúdo anterior
          containerRef.current.innerHTML = "";
          
          // Renderiza o DOCX
          await renderAsync(response.data, containerRef.current, null, {
            className: "docx", // Classe CSS para a "folha"
            inWrapper: false,  // Vamos controlar o wrapper manualmente no JSX
            ignoreWidth: false,
            ignoreHeight: false,
            breakPages: true,
            useBase64URL: true,
            useMathMLPolyfill: true
          });
        }
      } catch (err) {
        console.error("Erro ao renderizar DOCX:", err);
        if (isMounted) setError("Erro ao carregar o documento.");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadDocx();

    return () => {
      isMounted = false;
    };
  }, [url]);

  return (
    <div style={{ width: "100%",height, overflow: "auto", border: "1px solid #ccc", background: "#f0f0f0" }}>
      {loading && <div style={{ padding: 20, textAlign: "center" }}>Carregando documento...</div>}
      {error && <div style={{ padding: 20, color: "red", textAlign: "center" }}>{error}</div>}
      
      {/* Wrapper que aplica o fundo cinza (do CSS .docx-wrapper) */}
      <div className="docx-wrapper">
        {/* O docx-preview vai injetar as divs com a classe .docx aqui dentro */}
        <div ref={containerRef} />
      </div>
    </div>
  );
};

export default DocxViewer;